import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { ClientFileScheduleAndContractInfoModel } from '@core/services/client/client.model';

export enum ClientFileScheduleActionTypes{
    LOAD_FILESCHEDULE="[FileSchedule] Load FileSchedule",
    LOAD_FILESCHEDULE_SUCCESS="[FileSchedule] Load FileSchedule Success",
    LOAD_FILESCHEDULE_FAIL="[FileSchedule] Load FileSchedule Fail",
    CREATE_FILESCHEDULE="[FileSchedule] Create FileSchedule",
    CREATE_FILESCHEDULE_SUCCESS="[FileSchedule] Create FileSchedule Success",
    CREATE_FILESCHEDULE_FAIL="[FileSchedule] Create FileSchedule Fail",
    UPDATE_FILESCHEDULE="[FileSchedule] Update FileSchedule",
    UPDATE_FILESCHEDULE_SUCCESS="[FileSchedule] Update FileSchedule Success",
    UPDATE_FILESCHEDULE_FAIL="[FileSchedule] Update FileSchedule Fail",
}

 export class LOADFILESCHEDULE implements Action{
    readonly type=ClientFileScheduleActionTypes.LOAD_FILESCHEDULE;
    constructor(public payload:number) {}
 }

 export class LOADFILESCHEDULESUCCESS implements Action{
     readonly type=ClientFileScheduleActionTypes.LOAD_FILESCHEDULE_SUCCESS;
     constructor(public payload:ClientFileScheduleAndContractInfoModel) {}
  }

  export class LOADFILESCHEDULEFAIL implements Action{
     readonly type=ClientFileScheduleActionTypes.LOAD_FILESCHEDULE_FAIL;
     constructor(public payload:string) {}
  }

  export class CREATEFILESCHEDULE implements Action{
    readonly type=ClientFileScheduleActionTypes.CREATE_FILESCHEDULE;
    constructor(public payload:ClientFileScheduleAndContractInfoModel) {}
 }

 export class CREATEFILESCHEDULESUCCESS implements Action{
     readonly type=ClientFileScheduleActionTypes.CREATE_FILESCHEDULE_SUCCESS;
     constructor(public payload:ClientFileScheduleAndContractInfoModel) {}
  }

  export class CREATEFILESCHEDULEFAIL implements Action{
     readonly type=ClientFileScheduleActionTypes.CREATE_FILESCHEDULE_FAIL;
     constructor(public payload:string) {}
  }

  
  export class UPDATEFILESCHEDULE implements Action{
    readonly type=ClientFileScheduleActionTypes.UPDATE_FILESCHEDULE;
    constructor(public payload:ClientFileScheduleAndContractInfoModel) {}
 }

 export class UPDATEFILESCHEDULESUCCESS implements Action{
     readonly type=ClientFileScheduleActionTypes.UPDATE_FILESCHEDULE_SUCCESS;
     constructor(public payload:Update<ClientFileScheduleAndContractInfoModel>) {}
  }

  export class UPDATEFILESCHEDULEFAIL implements Action{
     readonly type=ClientFileScheduleActionTypes.UPDATE_FILESCHEDULE_FAIL;
     constructor(public payload:string) {}
  }


  export type FileScheduleAction=
  | LOADFILESCHEDULE  
  | LOADFILESCHEDULESUCCESS 
  | LOADFILESCHEDULEFAIL 
  | CREATEFILESCHEDULE  
  | CREATEFILESCHEDULESUCCESS 
  | CREATEFILESCHEDULEFAIL 
  | UPDATEFILESCHEDULE 
  | UPDATEFILESCHEDULESUCCESS 
  | UPDATEFILESCHEDULEFAIL; 
 